import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { createRoot } from 'react-dom/client';
import { ConfigProvider } from 'antd';
import theme from './theme';
import { Provider } from "react-redux";
import store from "./redux/store";
import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/flickity.css"
import "./assets/style.css"
import "./assets/index.css"
import reportWebVitals from './reportWebVitals';

createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <ConfigProvider theme={theme}>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </ConfigProvider>
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
